var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "material" },
    [
      !_vm.selectedMaterials
        ? _c("div", { staticClass: "no material-card" }, [
            _c("span", [_vm._v("Please select a material")])
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedMaterials
        ? _c(
            "div",
            { staticClass: "material-info-container" },
            [
              _c("object-main-info", {
                attrs: {
                  fields: _vm.fields,
                  identifier: _vm.material ? _vm.material.sm_reference : "",
                  "identifier-label":
                    _vm.$tc("Code", 1) + " / " + _vm.$tc("Reference", 1),
                  "editing-data": _vm.editingData,
                  "show-edit-button":
                    _vm.actionToExecute !== "CREATE_NEW_MATERIAL",
                  "card-label": _vm.cardLabel,
                  height: _vm.editingData ? "40%" : "30%"
                },
                on: {
                  "toggle-edit": _vm.toggleEdit,
                  "update-object": _vm.updateMaterial
                }
              }),
              _vm._v(" "),
              _c("material-specific-info", {
                attrs: {
                  materialFamilyID: _vm.materialFamilyID,
                  materialSpecificFields: _vm.material
                    ? _vm.material.family_specific_fields
                    : _vm.familySpecificFields,
                  accessories: _vm.accessoriesSelected,
                  others: _vm.othersSelected,
                  "editing-data": _vm.editingData,
                  lossValue: _vm.material ? _vm.material.sm_loss_value : null,
                  installationTypeOptions: _vm.installationTypeOptions,
                  "required-fields-filled": _vm.requiredFieldsAreFilled,
                  "submit-button-label": _vm.submitButtonLabel,
                  "custom-fields-inputs": _vm.customFieldsInputs,
                  "custom-fields-values": _vm.material
                    ? _vm.material.custom_fields
                    : {}
                },
                on: {
                  "update-material": _vm.updateMaterialSpecificField,
                  "update-custom-field": _vm.updateMaterialCustomField,
                  "update-loss-value": _vm.updateMaterial,
                  "update-required-field": function($event) {
                    _vm.specificRequiredFieldsAreFilled = $event
                  },
                  "cancel-edit": function($event) {
                    _vm.discardChangesDialogIsOpen = true
                  },
                  "save-material": function($event) {
                    _vm.saveChangesDialogIsOpen = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "absolute" },
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.saveChangesDialogIsOpen,
          title: _vm.$t("SaveChanges"),
          content: _vm.$t("SaveChangesContent"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-content-save",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.saveMaterial,
          secondaryAction: function($event) {
            _vm.saveChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.cancelEdit,
          secondaryAction: function($event) {
            _vm.discardChangesDialogIsOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a25a3ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a25a3ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/StockManagement/Material.vue
// module id = null
// module chunks = 